import { Icon, IconLike } from "components/Icon/Icon";
import OverflowTooltip from "components/Tooltip/OverflowTooltip";
import { TooltipProps } from "components/Tooltip/Tooltip";
import { memo } from "react";
export type AbstractStandardNodeProps = {
    icon?: IconLike;
    label: String;
    type: String;
    children?: React.ReactNode;
    className?: String;
    tooltipProps?: { placement?: TooltipProps["placement"]; align: TooltipProps["align"] };
};

export default memo(
    ({ label, icon, type, children, className, tooltipProps }: AbstractStandardNodeProps) => {
        return (
            <div className={`cloudomationGraphNode ${type}GraphNode ${className}`}>
                {children}
                <div className="shapeShadow" />
                <div className="shapeBorder" />
                <div className="shape" />
                <div className="labelContainer">
                    {icon && <Icon icon={icon} />}
                    <OverflowTooltip
                        overlay={label}
                        isOverlapping={false}
                        overlayStyle={{ zIndex: 2000 }}
                        tooltipProps={tooltipProps}
                    >
                        <div className="label">{`${label}`}</div>
                    </OverflowTooltip>
                </div>
            </div>
        );
    }
);
